import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import {Box, IconButton, useTheme} from "@mui/material";
import {Link, useSearchParams, useLocation} from "react-router-dom";

export interface PaginationActionsProps {
    count: number;
    page: number;
    rowsPerPage: number;
    onPageChange: (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => void;
}

export default function PaginationActions(props: PaginationActionsProps) {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const hash = location.hash;
    const theme = useTheme();
    const {count, page, rowsPerPage} = props;

    const firstSearchParams = new URLSearchParams(searchParams);
    firstSearchParams.set("page", `${0}`);

    const prevSearchParams = new URLSearchParams(searchParams);
    prevSearchParams.set("page", `${page - 1}`);

    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.set("page", `${page + 1}`);

    const lastSearchParams = new URLSearchParams(searchParams);
    lastSearchParams.set("page", `${Math.max(0, Math.ceil(count / rowsPerPage) - 1)}`);

    return (
        <Box sx={{flexShrink: 0, ml: 2.5}}>
            <IconButton
                component={Link}
                to={`?${firstSearchParams.toString()}${hash}`}
                disabled={page === 0}
                aria-label="first page"
                replace={true}
            >
                {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                component={Link}
                to={`?${prevSearchParams.toString()}${hash}`}
                disabled={page === 0}
                aria-label="previous page"
                replace={true}
            >
                {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                component={Link}
                to={`?${nextSearchParams.toString()}${hash}`}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
                replace={true}
            >
                {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                component={Link}
                to={`?${lastSearchParams.toString()}${hash}`}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
                replace={true}
            >
                {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}
